import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { GetPolicyFailure, GetPolicyRequest, GetPolicySuccess } from './actions';
import { HomePolicy } from '@models/swagger';

export const featureKey = 'getPolicy';

export interface State {
  data: HomePolicy | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetPolicyFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(GetPolicyRequest, state => ({ ...state, error: null, loading: true })),
    on(GetPolicySuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
